/**
 * ==========================================================
 * ET • Poll (v1.2)
 * - Idempotent init guard (prevents double-binding + double poll_view)
 * - Adds aria-pressed for accessibility
 * - Adds page context params to GA4 events
 * - No persistence yet (still privacy-friendly)
 * ==========================================================
 */
(function () {
  "use strict";

  function fireGa4(eventName, params) {
    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, params || {});
    }
  }

  function getPageContext() {
    return {
      page_path: window.location && window.location.pathname ? window.location.pathname : "",
      page_title: document && document.title ? document.title : "",
    };
  }

  function initPoll(pollEl) {
    if (!pollEl) return;

    // --- Init guard: prevents duplicate listeners / duplicate poll_view ---
    if (pollEl.dataset.etPollInit === "1") return;
    pollEl.dataset.etPollInit = "1";

    const pollId = pollEl.getAttribute("data-poll-id") || "";
    const pollType = pollEl.getAttribute("data-poll-type") || "";
    const resultsMode = pollEl.getAttribute("data-results-mode") || "none";

    const buttons = Array.from(pollEl.querySelectorAll(".et-poll__btn"));
    const noteEl = pollEl.querySelector(".et-poll__note");
    const noteAfterVote = noteEl ? noteEl.getAttribute("data-note-after-vote") : "";

    // Ensure baseline aria state
    buttons.forEach((b) => b.setAttribute("aria-pressed", "false"));

    // Fire view event once per poll element
    fireGa4("poll_view", {
      poll_id: pollId,
      poll_type: pollType,
      results_mode: resultsMode,
      content_type: "article",
      store: "ET",
      ...getPageContext(),
    });

    let voted = false;

    buttons.forEach((btn, idx) => {
      btn.addEventListener("click", function () {
        if (voted) return;
        voted = true;

        const answer = btn.getAttribute("data-answer") || "";

        // Visual confirmation
        btn.classList.add("is-selected");

        // Accessibility: pressed state
        buttons.forEach((b) => b.setAttribute("aria-pressed", b === btn ? "true" : "false"));

        // Dim non-selected
        buttons.forEach((b) => {
          if (b !== btn) b.classList.add("is-dim");
        });

        // Disable all options after vote
        buttons.forEach((b) => {
          b.disabled = true;
          b.setAttribute("aria-disabled", "true");
        });

        // Confirmation note
        if (noteEl) {
          noteEl.textContent = noteAfterVote
            ? noteAfterVote
            : "Thanks — your answer helps us improve future guides.";
        }

        // GA4 vote event
        fireGa4("poll_vote", {
          poll_id: pollId,
          poll_type: pollType,
          answer: answer,
          answer_index: idx + 1,
          results_mode: resultsMode,
          content_type: "article",
          store: "ET",
          ...getPageContext(),
        });

        //waleed code
        fetch('/apps/shop-app/api/proxy/vote', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({
            poll_id: pollId,
            answer: answer
          })
        })
        .then(r => r.json())
        .then(data => {
          console.log('Total votes:', data.totalVotes);
          console.log('Results:', data.results);
          

          
  const resultsContainer = document.getElementById('poll-results');
  
  try {

    // Clear container
    resultsContainer.innerHTML = '';
    
    // Create results header
    const header = document.createElement('h3');
    header.textContent = `Total Votes: ${data.totalVotes}`;
    resultsContainer.appendChild(header);
    
    // Render each result as a bar
    data.results.forEach((result) => {
      const resultItem = document.createElement('div');
      resultItem.className = 'poll-result-item';
      
      resultItem.innerHTML = `
        <div class="result-label">
          <span class="answer">${result.answer}</span>
          <span class="count">${result.count} (${result.percentage}%)</span>
        </div>
        <div class="result-bar-container">
          <div class="result-bar" style="width: ${result.percentage}%"></div>
        </div>
      `;
      
      resultsContainer.appendChild(resultItem);
    });
    
  } catch (error) {
    console.error('Error loading poll results:', error);
    resultsContainer.innerHTML = '<p>Failed to load results</p>';
  }



        });

      });
    });
  }

  function boot() {
    document.querySelectorAll("[data-et-poll]").forEach(initPoll);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
